'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const ArchiveBox = styled(Box)(({theme}) => ({
    paddingRight: '1.5rem',
    paddingLeft: '1.5rem',
    marginBottom: '1.5rem',
    [theme.breakpoints.down('md')]: {
        addingRight: '.7rem',
        paddingLeft: '.7rem',
        marginBottom: '.7rem',
    },
}));

export default ArchiveBox;
